









































import { DialogMixin, ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { Component, Mixins } from "vue-property-decorator";
import { FormatStructureEditableMixin } from "../../../mixins";
import { IQuestionnaire, Questionnaire } from "../../../../../../../documaker/domain/format/objects";
import { MultiOrderableCustomListBoxSelector } from "../../../../../../../base/components/system/selectors";
import { IDrawableQuestionnaireObjectEditable, instanceOfIDrawableQuestionnaireObjectEditable } from "../../../../../../domain/editableFormat/objectEditors";

@Component({
  components: {
    MultiOrderableCustomListBoxSelector,
  },
})
export default class QuestionnaireChildrenSelectDialog extends Mixins(DialogMixin, ModelEditableMixin, FormatStructureEditableMixin) {
  source: Questionnaire | null = null;
  selectedGuids: string[] = [];
  confirmed = false;

  get selectableGuids(): string[] {
    return this.selectableItems.map(i => i._guid);
  }

  get selectableItems(): IQuestionnaire[] {
    return this.sortedQuestionnaireObjects
      .map(o => o.questionnaire().getValue())
      .filter(i => 0 <= this.validGuids.indexOf(i._guid));
  }

  get sortedQuestionnaireObjects(): IDrawableQuestionnaireObjectEditable[] {
    return this.currentSortedQuestionnaireObjects.slice(this.getPostSourceIndex(this.sortedPagedQuestionnaireObjects[this.currentPageIndex]))
      .concat(...Array.from({ length: this.pageCount - 1 }, (_, i) => (this.currentPageIndex + i + 1) % this.pageCount).map(i => this.sortedPagedQuestionnaireObjects[i]))
      .concat(this.currentSortedQuestionnaireObjects.slice(0, this.getPostSourceIndex(this.sortedPagedQuestionnaireObjects[this.currentPageIndex])));
  }

  get sortedPagedQuestionnaireObjects(): IDrawableQuestionnaireObjectEditable[][] {
    return this.editingSource
      ? [...Array.from({ length: this.pageCount }, (_, i) => i).map(i => this.getSortedQuestionnaireObjects(i))]
      : [];
  }

  get currentSortedQuestionnaireObjects(): IDrawableQuestionnaireObjectEditable[] {
    return this.editingSource
      ? this.sortedPagedQuestionnaireObjects[this.currentPageIndex]
      : [];
  }

  private getSortedQuestionnaireObjects(pageIndex: number): IDrawableQuestionnaireObjectEditable[] {
    return this.pages[pageIndex].getObjects()
      .filter(o => instanceOfIDrawableQuestionnaireObjectEditable(o))
      .map(o => o as IDrawableQuestionnaireObjectEditable)
      .sort((a, b) => this.compareOrder(a, b));
  }

  private compareOrder(a: IDrawableQuestionnaireObjectEditable, b: IDrawableQuestionnaireObjectEditable): number {
    const aTopLeft = a.topLeft().getValue();
    const bTopLeft = b.topLeft().getValue();
    if (aTopLeft.y > bTopLeft.y) {
      return 1;
    } else if (aTopLeft.y < bTopLeft.y) {
      return -1;
    } else {
      if (aTopLeft.x > bTopLeft.x) {
        return 1;
      } else if (aTopLeft.x < bTopLeft.x) {
        return -1;
      } else {
        return 0;
      }
    }
  }

  private getPostSourceIndex(source: IDrawableQuestionnaireObjectEditable[]): number {
    const index = (source ? source : []).findIndex(o => this.areEqual(o, this.currentQuestionnaireObject));
    return 0 <= index ? index : 0;
  }

  private areEqual(a: IDrawableQuestionnaireObjectEditable, b: IDrawableQuestionnaireObjectEditable): boolean {
    return !!a && !!b && a.questionnaire().getValue()._guid === b.questionnaire().getValue()._guid;
  }

  get currentQuestionnaireObject(): IDrawableQuestionnaireObjectEditable {
    return this.source
      ? this.currentSortedQuestionnaireObjects.find(o => o.questionnaire().getValue()._guid === this.source._guid)
      : null;
  }

  get validGuids(): string[] {
    return (this.source ? this.sortedGuids : [])
      .filter(i => i !== this.source._guid)
      .filter(i => (this.childGuids.indexOf(i) < 0) || (0 <= this.source._childGuids.indexOf(i)))
      .filter(i => !this.isDescendant(i, this.source._guid));
  }

  private isDescendant(ancestorGuid: string, descendantGuid: string): boolean {
    const found = this.sortedQuestionnaireObjects.find(o => o.questionnaire().getValue()._guid === ancestorGuid);
    return found
        && (0 <= found.questionnaire().getValue()._childGuids.indexOf(descendantGuid) || found.questionnaire().getValue()._childGuids.some(i => this.isDescendant(i, descendantGuid)));
  }

  get childGuids(): string[] {
    return [].concat(...this.sortedQuestionnaireObjects.map(i => i.questionnaire().getValue()._childGuids));
  }

  get sortedGuids(): string[] {
    return this.sortedQuestionnaireObjects.map(i => i.questionnaire().getValue()._guid);
  }

  toType(guid: string): string {
    const found = this.selectableItems.find(i => i._guid === guid);
    return found ? found.type : null;
  }

  toLinkId(guid: string): string {
    const found = this.selectableItems.find(i => i._guid === guid);
    return found ? found.linkId : null;
  }

  toText(guid: string): string {
    const found = this.selectableItems.find(i => i._guid === guid);
    return found ? found.text : null;
  }

  async show(source: Questionnaire): Promise<string[]> {
    return this.showModal(async () => {
      this.source = source;
      this.selectedGuids = source._childGuids;
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.selectedGuids : null;
    });
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
